<template>
    <div>
        <file-upload :name="name" class="mr-1" @loaded="setAttachments"></file-upload>
    </div>
</template>

<script>
    import FileUpload from './FileUpload.vue';
    export default {
        components: {FileUpload},
        props: ['type'],
        data() {
            return {
                name: this.type,
                newAttachment: '',
            }
        },
        methods: {
            setAttachments(doc){
                console.log(doc);
                this.newAttachment = doc.file;
                this.addAttachment();
            },
            addAttachment() {
                let data = new FormData();
                data.append('attachment', this.newAttachment);
                axios.post('/coders/upload_'+ this.name, data).then(({data}) => {
                    location.reload();
                })
            },
        }
    }
</script>